import { matchPath } from 'react-router';
export default function matchedPath(pathname, matched) {
    var ssrRoute = {};
    try {
        ssrRoute = require('@@/core/route-server.json');
    }
    catch (err) { }
    var enterablePaths = Array.from(Object.keys(ssrRoute));
    enterablePaths.forEach(function (path) {
        var matchRes = matchPath(pathname, path) || matchPath(pathname.toLowerCase(), path);
        if (matchRes && matchRes.isExact) {
            Object.keys(matchRes).forEach(function (key) {
                matched[key] = matchRes[key];
            });
        }
    });
}
//# sourceMappingURL=matchedPath.js.map